var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUp1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_26833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9C20 8.46957 19.8084 7.96086 19.4675 7.58579C19.1265 7.21071 18.664 7 18.1818 7H12.4364L13.3091 2.43C13.3273 2.33 13.3364 2.22 13.3364 2.11C13.3364 1.7 13.1818 1.32 12.9364 1.05L11.9727 0L5.99091 6.58C5.65455 6.95 5.45455 7.45 5.45455 8V18C5.45455 18.5304 5.6461 19.0391 5.98708 19.4142C6.32805 19.7893 6.79052 20 7.27273 20H15.4545C16.2091 20 16.8545 19.5 17.1273 18.78L19.8727 11.73C19.9545 11.5 20 11.26 20 11V9ZM0 20H3.63636V8H0V20Z",
    fill: "#01A722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_26833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.5062,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUp1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbs-up 1.2d0183e9c5c268871a372cfffe78a67c.svg";